const norm = (value) =>
  String(value ?? "")
    .trim()
    .toUpperCase()

export const partitionByClients = (rows = [], clients = []) => {
  const set = new Set(clients.map(norm))
  const inClients = []
  const others = []
  for (const row of rows) {
    if (set.has(norm(row?.PatientIssuer))) inClients.push(row)
    else others.push(row)
  }
  return { inClients, others }
}
